import __var_0__ from '@stdlib/utils/constant-function';
import __var_1__ from '@stdlib/math/base/assert/is-nan';
import __var_2__ from '@stdlib/math/base/special/log1p';
import __var_3__ from '@stdlib/math/base/special/exp';
import __var_4__ from '@stdlib/constants/math/float64-ninf';
import __var_5__ from '@stdlib/constants/math/float64-pinf';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var constantFunction = __var_0__;
var isnan = __var_1__;
var log1p = __var_2__;
var exp = __var_3__;
var NINF = __var_4__;
var PINF = __var_5__;


// MAIN //

/**
* Returns a function for evaluating the natural logarithm of the cumulative distribution function (CDF) for an exponential distribution with rate parameter `lambda`.
*
* @param {PositiveNumber} lambda - rate parameter
* @returns {Function} logCDF
*
* @example
* var logcdf = factory( 0.5 );
* var y = logcdf( 3.0 );
* // returns ~-0.252
*
* y = logcdf( 1.0 );
* // returns ~-0.933
*/
function factory( lambda ) {
	if (
		isnan( lambda ) ||
		lambda < 0.0 ||
		lambda === PINF
	) {
		return constantFunction( NaN );
	}
	return logcdf;

	/**
	* Evaluates the natural logarithm of the cumulative distribution function (CDF) for an exponential distribution.
	*
	* @private
	* @param {number} x - input value
	* @returns {number} evaluated logCDF
	*
	* @example
	* var y = logcdf( 2.0 );
	* // returns <number>
	*/
	function logcdf( x ) {
		if ( x < 0.0 ) {
			return NINF;
		}
		return log1p( -exp( -lambda * x ) );
	}
}


// EXPORTS //
export default factory;
